import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import { StyleSheet } from "react-native";
import { graphql } from "@oui/lib/src/graphql/tada";
import { encodeHostedQuizSetSlug } from "@oui/lib/src/quizSetSlug";
import { useI18n } from "../../../lib/i18n";
import { ActivityIndicator } from "../../ActivityIndicator";
import { ChatArtifactPreview } from "../../ChatArtifactPreview";
import { ErrorPresenter } from "../../ErrorPresenter";
import { Heading } from "../../Text";
import { View } from "../../View";
// @no-fast-refresh-strip
export var SessionVideosQuery = graphql("\n  query SessionVideos($contentType: String!) {\n    user {\n      ID\n      role {\n        ID\n        sessions(contentType: $contentType) {\n          progress {\n            completed\n          }\n          session {\n            sessionID\n            content {\n              activities {\n                name\n                params\n              }\n              quizSetCollections {\n                quizSetCollectionID\n                name\n              }\n              contentTypes\n            }\n          }\n        }\n      }\n    }\n  }\n");
/**
 * Renders list of `QuizSet`s associated with the provided `contentType`. This
 * is typically the same list of sets as is available through the chatbot
 * content for the corresponding session.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-138}
 */ export function SessionVideos(param) {
    var testID = param.testID, contentType = param.contentType;
    var _data_user_role_sessions__session_content, _data_user_role_sessions_, _data_user_role, _data_user;
    var $t = useI18n().$t;
    var navigate = useNavigation().navigate;
    var _useQuery = useQuery(SessionVideosQuery, {
        variables: {
            contentType: contentType
        },
        fetchPolicy: 'cache-first'
    }), data = _useQuery.data, loading = _useQuery.loading, error = _useQuery.error;
    var collections = data === null || data === void 0 ? void 0 : (_data_user = data.user) === null || _data_user === void 0 ? void 0 : (_data_user_role = _data_user.role) === null || _data_user_role === void 0 ? void 0 : (_data_user_role_sessions_ = _data_user_role.sessions[0]) === null || _data_user_role_sessions_ === void 0 ? void 0 : (_data_user_role_sessions__session_content = _data_user_role_sessions_.session.content) === null || _data_user_role_sessions__session_content === void 0 ? void 0 : _data_user_role_sessions__session_content.quizSetCollections;
    var _collections_length;
    return /*#__PURE__*/ _jsxs(View, {
        testID: testID,
        style: [
            {
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'space-between'
            }
        ],
        spacing: 15,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                level: 2,
                text: $t({
                    id: 'Conversation_videoTabVideosHeadline',
                    defaultMessage: 'Videos'
                })
            }),
            loading ? /*#__PURE__*/ _jsx(View, {
                style: {
                    flex: 1,
                    marginVertical: 30,
                    flexWrap: 'wrap',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-around'
                },
                children: /*#__PURE__*/ _jsx(ActivityIndicator, {
                    size: "large",
                    style: StyleSheet.absoluteFillObject
                })
            }) : /*#__PURE__*/ _jsxs(View, {
                style: [
                    {
                        flex: 1,
                        flexWrap: 'wrap',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        margin: 5
                    }
                ],
                children: [
                    error ? /*#__PURE__*/ _jsx(ErrorPresenter, {
                        error: error
                    }) : null,
                    collections === null || collections === void 0 ? void 0 : collections.map(function(collection, i) {
                        return /*#__PURE__*/ _jsx(View, {
                            style: {
                                marginBottom: i < collections.length - 2 ? 40 : 0
                            },
                            children: /*#__PURE__*/ _jsx(ChatArtifactPreview, {
                                _width: 159,
                                _height: 177,
                                _onSideEffect: function() {
                                    navigate('QuizSet', {
                                        slug: encodeHostedQuizSetSlug({
                                            quizSetCollectionID: collection.quizSetCollectionID
                                        })
                                    });
                                },
                                _borderColor: "transparent",
                                artifactName: "QuizSet",
                                params: {
                                    slug: encodeHostedQuizSetSlug({
                                        quizSetCollectionID: collection.quizSetCollectionID
                                    })
                                },
                                linkText: collection.name
                            })
                        }, collection.quizSetCollectionID);
                    }),
                    ((_collections_length = collections === null || collections === void 0 ? void 0 : collections.length) !== null && _collections_length !== void 0 ? _collections_length : 0) % 2 === 1 ? /*#__PURE__*/ _jsx(View, {
                        style: {
                            width: 159
                        }
                    }) : null
                ]
            })
        ]
    });
}
